module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/266.6f0b6ae9.png";